import { useEffect, useState } from "react";
import { Gift, ExternalLink } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function PartnersPage() {
  const [partners, setPartners] = useState(null);
  useEffect(() => {
    api.get("/partners").then(({ data }) => setPartners(data.partners)).catch(() => setPartners([]));
  }, []);

  return (
    <div className="mx-auto max-w-4xl px-6 py-10 md:px-10" data-testid="partners-page">
      <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Perks</p>
      <h1 className="mt-2 font-display text-3xl font-medium tracking-tight sm:text-4xl">
        <Gift className="mr-1 inline h-6 w-6" /> Partner Offers
      </h1>
      <p className="mt-2 max-w-2xl text-muted-foreground">
        These services support your money journey inside Zuntria — getting paid (business banking), staying protected
        (insurance) and keeping your books clean (accounting). Zuntria may earn a referral fee, at no extra cost to you.
      </p>
      <p className="mt-2 max-w-2xl rounded-xl border border-border bg-card px-4 py-2.5 text-xs text-muted-foreground" data-testid="partners-disclaimer">
        These are external services that open in a new tab. Clicking a link does not connect an account to Zuntria —
        an account only shows as connected once it's verified.
      </p>
      {partners === null ? (
        <p className="mt-10 text-muted-foreground">Loading…</p>
      ) : (
        <div className="mt-8 grid gap-4 sm:grid-cols-2">
          {partners.map((p) => (
            <div key={p.partner_id} className="flex flex-col rounded-2xl border border-border bg-card p-6" data-testid={`partner-${p.partner_id}`}>
              <span className="w-fit rounded-full bg-accent/10 px-2.5 py-1 text-xs capitalize text-accent">{p.category}</span>
              <h2 className="mt-3 font-display text-lg">{p.name}</h2>
              <p className="mt-1 flex-1 text-sm text-muted-foreground">{p.offer}</p>
              <Button
                className="mt-4 w-fit"
                onClick={() => window.open(`${process.env.REACT_APP_BACKEND_URL}/api/partners/go/${p.partner_id}`, "_blank")}
                data-testid={`partner-cta-${p.partner_id}`}>
                {p.cta || "Get offer"} <ExternalLink className="ml-2 h-3.5 w-3.5" />
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
